import { BusinessGoal, Plan, Project, Scenario, UUID } from "@/types/project";

export class ProjectService {
  private project: Project;

  constructor(project: Project) {
    this.project = project;
  }

  getScenarioById(scenarioId: string): Scenario | undefined {
    for (const bg of this.project.business_goals ?? []) {
      for (const plan of bg.plans ?? []) {
        const scenario = (plan.scenarios ?? []).find((s) => s.id === scenarioId);
        if (scenario) {
          return scenario;
        }
      }
    }
    return undefined;
  }

  getPlanById(planId: string): Plan | undefined {
    for (const bg of this.project.business_goals ?? []) {
      const plan = (bg.plans ?? []).find((p) => p.id === planId);
      if (plan) {
        return plan;
      }
    }
    return undefined;
  }

  getBusinessGoalById(businessGoalId: UUID): BusinessGoal | undefined {
    return (this.project.business_goals ?? []).find((bg) => bg.id === businessGoalId);
  }

  getPlanByScenarioId(scenarioId: string): Plan | undefined {
    for (const bg of this.project.business_goals ?? []) {
      for (const plan of bg.plans ?? []) {
        const scenario = (plan.scenarios ?? []).find((s) => s.id === scenarioId);
        if (scenario) {
          return plan;
        }
      }
    }
    return undefined;
  }

  pickPlanScenarioFilter(planId: string): UUID | undefined {
    const plan = this.getPlanById(planId);
    if (!plan) return undefined;

    const scenarios = plan.scenarios ?? [];
    if (scenarios.length === 0) return undefined;

    const approvedScenario = scenarios.find((s) => s.approved === true);
    if (approvedScenario) {
      return approvedScenario.id;
    }

    return scenarios[0].id;
  }
}
